import React from 'react';
import { StaticQuery, graphql } from 'gatsby';
import Img from "gatsby-image"
// Create a GraphQL query for the comment list.

const dictionary = require("../dic/dic.json");
// Main component class.
class TopArticles extends React.Component {
	// Render stuff.


	render() {
		return (
          <div>
  					<span className="title-section">{dictionary[this.props.lang].title_destacados}</span>
  					<div className="list">
                {this.props.destacados.map((post) => (
                  <article className="post">
                    <div className="top">
                      <a href={`/${this.props.lang}/${this.props.categoria}/${post.slug}`} class="thumbnail">
											  {post.featuredImage!=null && post.featuredImage.node!=null && post.featuredImage.node.localFile!=null
													?
													<Img
	                        fluid={post.featuredImage.node.localFile.childImageSharp.fluid}
	                        />
													:
													null
												}
                      </a>
                      <div className="info">
                        <span className="title"><a href={`/${this.props.lang}/${this.props.categoria}/${post.slug}`}>{post.title}</a></span>
                      </div>
                    </div>
                  </article>
                ))}
            </div>
          </div>
 		);
	}
}


export default TopArticles;
